var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("event-details-popup", {
        attrs: { visible: _vm.showEventDetails, event: _vm.currentEvent },
        on: {
          "update:visible": function ($event) {
            _vm.showEventDetails = $event
          },
          reschedule: _vm.rescheduleFromDetails,
          cancel: _vm.cancelFromDetails,
          confirm: _vm.confirmFromDetails,
        },
      }),
      _c("reschedule-modal", {
        attrs: {
          "modal-id": "student-reschedule-modal",
          visible: _vm.showRescheduleModal,
          title: _vm.$t("lesson.reschedule"),
          message: _vm.rescheduleMessage,
          "justification-label": _vm.$t("lesson.justification_placeholder"),
          "justification-placeholder": _vm.$t(
            "lesson.justification_placeholder"
          ),
          "ok-title": _vm.$t("action.confirm"),
          "cancel-title": _vm.$t("action.cancel"),
          "error-message": _vm.$t("lesson.justification_required"),
          "reference-id": _vm.getReferenceId,
        },
        on: {
          confirm: _vm.confirmReschedule,
          cancel: function ($event) {
            _vm.showRescheduleModal = false
          },
          "update:visible": function ($event) {
            _vm.showRescheduleModal = $event
          },
        },
      }),
      _c("cancel-modal", {
        attrs: {
          "modal-id": "student-cancel-modal",
          visible: _vm.showCancelModal,
          title: _vm.$t("lesson.cancel_schedule"),
          message: _vm.cancelMessage,
          "justification-label": _vm.$t("lesson.justification_placeholder"),
          "justification-placeholder": _vm.$t(
            "lesson.justification_placeholder"
          ),
          "ok-title": _vm.$t("yes"),
          "cancel-title": _vm.$t("no"),
          "error-message": _vm.$t("lesson.justification_required"),
        },
        on: {
          confirm: _vm.confirmCancel,
          cancel: function ($event) {
            _vm.showCancelModal = false
          },
          "update:visible": function ($event) {
            _vm.showCancelModal = $event
          },
        },
      }),
      _c("confirm-modal", {
        attrs: {
          "modal-id": "student-confirm-modal",
          visible: _vm.showConfirmModal,
          title: _vm.$t("lesson.confirm_completion"),
          message: _vm.confirmMessage,
          "justification-label": _vm.$t("lesson.observations_placeholder"),
          "justification-placeholder": _vm.$t(
            "lesson.observations_placeholder"
          ),
          "ok-title": _vm.$t("action.confirm"),
          "cancel-title": _vm.$t("action.cancel"),
          "require-justification": false,
        },
        on: {
          confirm: _vm.confirmCompletion,
          cancel: function ($event) {
            _vm.showConfirmModal = false
          },
          "update:visible": function ($event) {
            _vm.showConfirmModal = $event
          },
        },
      }),
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_grid_path: "/students/events/grid",
          order_column: "start_at",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "title", attrs: { "sort-key": "title" } }, [
                  _vm._v(_vm._s(_vm.$t("lesson.title"))),
                ]),
                _c(
                  "vs-th",
                  { key: "start_at", attrs: { "sort-key": "start_at" } },
                  [_vm._v(_vm._s(_vm.$t("schedule.start_at")))]
                ),
                _c(
                  "vs-th",
                  { key: "end_at", attrs: { "sort-key": "end_at" } },
                  [_vm._v(_vm._s(_vm.$t("schedule.end_at")))]
                ),
                _c(
                  "vs-th",
                  { key: "status", attrs: { "sort-key": "status" } },
                  [_vm._v(_vm._s(_vm.$t("lesson.status")))]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "title", attrs: { width: "40%" } }, [
                      _c("span", [_vm._v(_vm._s(tr.data.title))]),
                    ]),
                    _c("vs-td", { key: "start_at", attrs: { width: "20%" } }, [
                      _c("div", [
                        _vm._v(_vm._s(_vm.formatDateTime(tr.start_at))),
                      ]),
                    ]),
                    _c("vs-td", { key: "end_at", attrs: { width: "20%" } }, [
                      _c("div", [
                        _vm._v(_vm._s(_vm.formatDateTime(tr.end_at))),
                      ]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "status", attrs: { width: "10%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base",
                            attrs: {
                              transparent: "",
                              color: _vm._.get(tr, "status.color"),
                            },
                          },
                          [_vm._v(_vm._s(_vm._.get(tr, "status.label")))]
                        ),
                      ],
                      1
                    ),
                    _c("vs-td", { attrs: { width: "10%" } }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top",
                                value: {
                                  content: _vm.$t("action.consult"),
                                  delay: { show: 100, hide: 100 },
                                },
                                expression:
                                  "{\n                content: $t('action.consult'),\n                delay: { show: 100, hide: 100 }\n              }",
                                modifiers: { top: true },
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-primary cursor-pointer",
                            attrs: { icon: "EyeIcon" },
                            on: {
                              click: function ($event) {
                                return _vm.viewDetails(tr)
                              },
                            },
                          }),
                          _vm.canConfirm(tr)
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "my_lessons.confirm",
                                    expression: "'my_lessons.confirm'",
                                  },
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.top",
                                    value: {
                                      content: _vm.$t(
                                        "lesson.confirm_completion"
                                      ),
                                      delay: { show: 100, hide: 100 },
                                    },
                                    expression:
                                      "{\n                content: $t('lesson.confirm_completion'),\n                delay: { show: 100, hide: 100 }\n              }",
                                    modifiers: { top: true },
                                  },
                                ],
                                staticClass:
                                  "h-5 w-5 mb-1 mr-1 stroke-current text-success cursor-pointer",
                                attrs: { icon: "CheckCircleIcon" },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmDone(tr)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.canReschedule(tr)
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "my_lessons.reschedule",
                                    expression: "'my_lessons.reschedule'",
                                  },
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.top",
                                    value: {
                                      content: _vm.$t("lesson.reschedule"),
                                      delay: { show: 100, hide: 100 },
                                    },
                                    expression:
                                      "{\n                content: $t('lesson.reschedule'),\n                delay: { show: 100, hide: 100 }\n              }",
                                    modifiers: { top: true },
                                  },
                                ],
                                staticClass:
                                  "h-5 w-5 mb-1 mr-1 stroke-current text-primary cursor-pointer",
                                attrs: { icon: "CalendarIcon" },
                                on: {
                                  click: function ($event) {
                                    return _vm.reschedule(tr)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.canCancel(tr)
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "my_lessons.cancel",
                                    expression: "'my_lessons.cancel'",
                                  },
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.top",
                                    value: {
                                      content: _vm.$t("lesson.cancel_schedule"),
                                      delay: { show: 100, hide: 100 },
                                    },
                                    expression:
                                      "{\n                content: $t('lesson.cancel_schedule'),\n                delay: { show: 100, hide: 100 }\n              }",
                                    modifiers: { top: true },
                                  },
                                ],
                                staticClass:
                                  "h-5 w-5 mb-1 mr-1 stroke-current text-danger cursor-pointer",
                                attrs: { icon: "XCircleIcon" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cancel(tr)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }